import { templates } from '@/api'

const getTemplates = async (context, { page, search }) => {
  context.commit('LOADING_UPDATED', true)
  try {
    let count = await templates.count(search)
    let response = await templates.fetch({ page, search })
    context.commit('TEMPLATES_UPDATED', response.data)
    context.commit('PAGINATION_UPDATED', { page, total: count.data.count })
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
    throw e
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

const getTemplatesStats = async (context) => {
  try {
    let stats = await context.state.templates.forEach(async (template) => {
      let response = await templates.countOne(template.id)
      context.commit('TEMPLATES_UPDATED', context.state.templates.map(el => {
        if (el.id === template.id) {
          el.totalList = response.data.count
        }
        return el
      }))
      return 'SUCCESS'
    })
    return stats
  } catch (e) {
    throw e
  }
}

const getTemplate = async (context, id) => {
  context.commit('TEMPLATE_UPDATED', {})
  try {
    let response = await templates.fetchOne(id)
    context.commit('TEMPLATE_UPDATED', response.data)
    context.commit('SECTIONS_UPDATED', response.data._sections)
    return response
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
    throw e
  }
}

const createTemplate = async (context, template) => {
  context.commit('LOADING_UPDATED', true)
  try {
    let response = await templates.create(template)
    return response.data.id
  } catch (e) {
    throw e
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

/**
 * Duplicate a template
 * @param {Object} context Vuex methods
 * @param {Object} duplicateTemplate all the data needed to create a new template
 */
const duplicateTemplate = async (context, duplicateTemplate) => {
  try {
    // create a template with the same configuration than the original
    let newTemplateId = await createTemplate(context, { name: duplicateTemplate.name, size: duplicateTemplate.size })
    // attribute to the newly created template the same sections than the original template
    let response = await updateSections(context, { templateId: newTemplateId, sections: duplicateTemplate.sections })
    // Add initial value to totalList
    response.data.totalList = 0
    // update the list of templates
    context.commit('TEMPLATES_UPDATED', [response.data, ...context.state.templates])
  } catch (e) {
    throw e
  }
}

const deleteTemplate = async (context, id) => {
  context.commit('TEMPLATE_UPDATED', {})
  try {
    let response = await templates.delete(id)
    // Remove widget from template
    context.commit('TEMPLATES_UPDATED', context.state.templates.filter(template => template.id !== id))
    return response
  } catch (e) {
    throw e
  }
}

const createSection = async (context, { templateId, name, size }) => {
  try {
    let response = await templates.createSection(templateId, {
      name,
      size
    })
    return response
  } catch (e) {
    throw e
  }
}

const deleteSection = async (context, { templateId, sectionId }) => {
  try {
    context.commit('SECTIONS_UPDATED', context.state.sections.filter(section => section.id !== sectionId))
    return 'SUCCESS'
  } catch (e) {
    throw e
  }
}

const updateSections = async (context, { templateId, sections }) => {
  try {
    let updateRequest = await templates.updateSections(templateId, sections.map(section => {
      section.id = '_' + Math.random().toString(36).substr(2, 9)
      return section
    }))
    return updateRequest
  } catch (e) {
    throw e
  }
}

export default {
  getTemplates,
  getTemplatesStats,
  getTemplate,
  createTemplate,
  duplicateTemplate,
  deleteTemplate,
  createSection,
  deleteSection,
  updateSections
}



// WEBPACK FOOTER //
// ./src/store/modules/templates/actions.js